// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { OpticalOrderPodOrderResponse } from './optical-order-pod-order-response';

// @ts-ignore
import { ReferenceDataSummaryResponse } from './reference-data-summary-response';

/** See com.rev360.pms.api.controller.patient.opticalsummary.OpticalOrderPodEyeglassResponse */
/* istanbul ignore next */
@GandalfModel
export class OpticalOrderPodEyeglassResponse extends OpticalOrderPodOrderResponse {

	@GandalfProperty({ designType: String })
	brand!: string | null;

	@GandalfProperty({ designType: String })
	color!: string | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: Number })
	eye!: number | null;

	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfProperty({ designType: String })
	model!: string | null;

	@GandalfProperty({ designType: Boolean })
	onHold!: boolean | null;

	@GandalfProperty({ designType: Number })
	orderId!: number | null;

	@GandalfConstantDecorator(constants.OrderType)
	@GandalfProperty({ designType: constants.OrderType })
	orderType!: constants.OrderType | null;

	@GandalfConstantDecorator(constants.OrderStatusCode)
	@GandalfProperty({ designType: constants.OrderStatusCode })
	status!: constants.OrderStatusCode | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	statusDate!: Date | null;

	@GandalfProperty({ designType: ReferenceDataSummaryResponse })
	usedFor!: ReferenceDataSummaryResponse | null;

}
